import * as types from '../mutation-types'
import { api } from '@/modules/api'
const actions = {
  async updateGeneralKillerSettings ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.generalKillerFeatureSettings.updateSettings(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Settings were successfully updated!')
    } catch (err) {
      commit(types.CREATE_ERROR_MESSAGE, 'Failed to update settings')
      throw err
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/killerFeatureSettings.js